function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(88.627451%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(88.627451%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 274.098285 35.498309 L 174.603845 109.402075 L 192.999573 65.80459 Z M 274.098285 35.498309 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 44.404486 35.498309 L 143.101648 110.102124 L 125.600427 65.80459 Z M 238.298566 206.796368 L 211.803662 247.3992 L 268.497894 263.004456 L 284.803198 207.700598 Z M 33.903754 207.700598 L 50.102106 263.004456 L 106.796338 247.3992 L 80.301434 206.796368 Z M 33.903754 207.700598 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 103.597504 138.201306 L 87.797791 162.100195 L 144.103107 164.598981 L 142.100189 104.103094 Z M 214.895544 138.201306 L 175.896991 103.403046 L 174.603845 164.598981 L 230.802209 162.100195 Z M 106.796338 247.3992 L 140.602863 230.899438 L 111.39527 208.099237 Z M 177.899908 230.899438 L 211.803662 247.3992 L 207.097778 208.099237 Z M 177.899908 230.899438 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(84.313725%,75.686275%,70.196078%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(84.313725%,75.686275%,70.196078%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 211.803662 247.3992 L 177.899908 230.899438 L 180.602875 252.999591 L 180.301465 262.304407 Z M 106.796338 247.3992 L 138.298535 262.304407 L 138.104077 252.999591 L 140.602863 230.899438 Z M 106.796338 247.3992 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(13.72549%,20.392157%,27.843137%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,20.392157%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 138.804126 193.495441 L 110.597992 185.201807 L 130.500769 176.101172 Z M 179.698645 193.495441 L 188.002002 176.101172 L 208.002008 185.201807 Z M 179.698645 193.495441 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(80.392157%,38.039216%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.392157%,38.039216%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 106.796338 247.3992 L 111.599451 206.796368 L 80.301434 207.700598 Z M 207.000549 206.796368 L 211.803662 247.3992 L 238.298566 207.700598 Z M 230.802209 162.100195 L 174.603845 164.598981 L 179.795874 193.495441 L 188.099231 176.101172 L 208.099237 185.201807 Z M 110.597992 185.201807 L 130.597998 176.101172 L 138.804126 193.495441 L 144.103107 164.598981 L 87.797791 162.100195 Z M 110.597992 185.201807 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,45.882353%,12.156863%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,45.882353%,12.156863%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 87.797791 162.100195 L 111.39527 208.099237 L 110.597992 185.201807 Z M 208.099237 185.201807 L 207.097778 208.099237 L 230.802209 162.100195 Z M 144.103107 164.598981 L 138.804126 193.495441 L 145.396252 227.603375 L 146.903302 182.703021 Z M 174.603845 164.598981 L 171.900879 182.596069 L 173.096796 227.603375 L 179.795874 193.495441 Z M 174.603845 164.598981 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 179.795874 193.495441 L 173.096796 227.603375 L 177.899908 230.899438 L 207.097778 208.099237 L 208.099237 185.201807 Z M 110.597992 185.201807 L 111.39527 208.099237 L 140.602863 230.899438 L 145.396252 227.603375 L 138.804126 193.495441 Z M 110.597992 185.201807 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(75.294118%,67.843137%,61.960784%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(75.294118%,67.843137%,61.960784%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 180.301465 262.304407 L 180.602875 252.999591 L 178.104089 250.802216 L 140.398682 250.802216 L 138.104077 252.999591 L 138.298535 262.304407 L 106.796338 247.3992 L 117.802661 256.402606 L 140.097272 271.900909 L 178.395776 271.900909 L 200.797339 256.402606 L 211.803662 247.3992 Z M 180.301465 262.304407 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(8.627451%,8.627451%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(8.627451%,8.627451%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 177.899908 230.899438 L 173.096796 227.603375 L 145.396252 227.603375 L 140.602863 230.899438 L 138.104077 252.999591 L 140.398682 250.802216 L 178.104089 250.802216 L 180.602875 252.999591 Z M 177.899908 230.899438 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(46.27451%,23.921569%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(46.27451%,23.921569%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 278.298578 114.195465 L 286.796393 73.398175 L 274.098285 35.498309 L 177.899908 106.90329 L 214.895544 138.201306 L 267.204749 153.495428 L 278.804169 140.000043 L 273.796875 136.40257 L 281.798822 129.100671 L 275.595612 124.297559 L 283.597559 118.2013 Z M 31.803607 73.398175 L 40.301422 114.195465 L 34.89549 118.2013 L 42.897437 124.297559 L 36.801178 129.100671 L 44.803125 136.40257 L 39.795831 140.000043 L 51.298022 153.495428 L 103.597504 138.201306 L 140.602863 106.90329 L 44.404486 35.498309 Z M 31.803607 73.398175 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 267.204749 153.495428 L 214.895544 138.201306 L 230.802209 162.100195 L 207.097778 208.099237 L 238.298566 207.700598 L 284.803198 207.700598 Z M 103.597504 138.201306 L 51.298022 153.495428 L 33.903754 207.700598 L 80.301434 207.700598 L 111.39527 208.099237 L 87.797791 162.100195 Z M 174.603845 164.598981 L 177.899908 106.90329 L 193.096802 65.80459 L 125.600427 65.80459 L 140.602863 106.90329 L 144.103107 164.598981 L 145.299023 182.80025 L 145.396252 227.603375 L 173.096796 227.603375 L 173.300977 182.80025 Z M 174.603845 164.598981 ",
    transform: "matrix(0.401758,0,0,0.401758,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.850ba6c3047e96450df812dd0dd5b0f4.svg";
export { ForwardRef as ReactComponent };